import { useEffect, useState } from "react";

/**
 * Devuelve el valor recien cuando dejo de cambiar por `ms` milisegundos.
 *
 * POR QUE 250 ms EN LA BUSQUEDA DE PRECIOS
 * ----------------------------------------
 * Escribir "iphone 15 pro max" son 18 teclas. Sin debounce eso son 18 consultas
 * a `buscar_precio`, cada una con su similitud trigram sobre el catalogo entero,
 * y 17 de ellas ya no le importan a nadie cuando llegan. Con 250 ms queda una
 * sola: el tiempo entre teclas de alguien tipeando normal es menor, y el tiempo
 * que una persona tolera esperando es mayor.
 *
 * El timer se limpia en el cleanup: sin eso, desmontar el componente mientras
 * hay un debounce pendiente dispara un `setState` sobre algo que ya no existe.
 */
export function useDebounce<T>(valor: T, ms = 250): T {
  const [demorado, setDemorado] = useState<T>(valor);

  useEffect(() => {
    const t = setTimeout(() => setDemorado(valor), ms);
    return () => clearTimeout(t);
  }, [valor, ms]);

  return demorado;
}
